import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'v2m-function-archive',
  templateUrl: './function-archive.component.html',
  styleUrls: ['./function-archive.component.scss']
})
export class FunctionArchiveComponent implements OnInit {
  constructor(private seo: SeoService) {}

  ngOnInit() {
    this.seo.updateTitle('video2manual - Funktions-Historie');
    this.seo.updateKeywords('video2manual,Versionen');
  }
}
